/** Whether `index` comes at or before `compareTo` in reading order: matrix by matrix, column by column, row by row. */
export function doesIndexInclude(index: [matrix: number, col: number, row: number], compareTo: [matrix: number, col: number, row: number]) {
  return (
    index[0] < compareTo[0] ||
    (index[0] === compareTo[0] && index[1] < compareTo[1]) ||
    (index[0] === compareTo[0] && index[1] === compareTo[1] && index[2] <= compareTo[2])
  );
}
